<template>
  <object :data="file" width="100%" height="100%" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "object-view",
  props: {
    file: { type: String, default: "" },
  },
});
</script>
